<template>
    <el-dialog
        class="roundWarnDialog"
        :title="'轮次报价监控'"
        :visible.sync="warnShow"
        width="840px"
        :close-on-click-modal="false"
        @close="close"
        height="600px"
    >
        <div style="display:flex;margin-bottom:12px;">
            <el-input style="width:200px;margin-right:12px" v-model="searchInfo.supplierName" placeholder="供应商名称" size="mini" clearable></el-input>
            <mSelect v-if="optionArr.length" style="width:200px;margin-right:12px" class="el-input" :optionArr="optionArr" :value="searchInfo.tenderStatus"
                :placeholder="'轮次报价状态'" :filterable="true" @input="getTenderStatus" :key="optionArrKey" ></mSelect>
            <span class="padding-left"><el-button type="primary" size="mini" @click="searchFn">查 询</el-button></span>
            <span class="padding-left" style="margin-left:12px"><el-button type="primary" size="mini" @click="exportFn">导 出</el-button></span>
        </div>
        <el-table
            v-loading="loading"
            :data="roundwarntableList"
            border
            stripe
            ref="roundwarntable"
            class="roundwarn-tab-list"
            height="430"
        >
            <el-table-column
                v-for="(item, index) in columnsList"
                :key="index"
                :prop="item.prop"
                :label="item.label"
            >
                <template slot-scope="scope">
                    <span v-if="scope.column.label === '供应商编码'">{{scope.row.supplierCode}}</span>
                    <span v-if="scope.column.label === '供应商名称'">{{scope.row.supplierName}}</span>
                    <span v-if="scope.column.label === '操作状态'">{{scope.row.tenderStatusText}}</span>
                </template>
            </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
            <el-pagination
            class="text-right"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNo"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next"
            :total="totalCount">
        </el-pagination>
            <el-button size="mini" type="primary" @click="close">关闭</el-button>
        </div>
    </el-dialog>
</template>
<script>
import config from '@/config/user.env';
import mSelect from '@/components/lots/otpSelect2';
import { bidTenderSuppliers } from '../../../api/tenderDetails.js';
import { dictWithUrl } from '@/components/lots/api';
export default {
    components: { mSelect },
    props: {
        warnShowFlag: {
            type: Boolean,
            default() {
                return false;
            }
        },
        tenderCode: {
            type: String,
            default() {
                return '';
            }
        }
    },
    data() {
        return {
            searchInfo: {
                supplierName: '',
                tenderStatus: ''
            },
            pageNo: 1,
            pageSize: 10,
            totalCount: 0,
            warnShow: false,
            loading: false,
            roundwarntableList: [],
            dictData: [],
            optionArr: [],
            optionArrKey: 0,
            columnsList: [
                {
                    prop: 'supplierCode',
                    label: '供应商编码',
                    width: '180'
                },
                {
                    prop: 'supplierName',
                    label: '供应商名称',
                    width: '180'
                },
                {
                    prop: 'tenderStatus',
                    label: '操作状态',
                    width: '180'
                }
            ]
        };
    },
    methods: {
        getTenderStatus(value) {
            this.searchInfo.tenderStatus = value;
        },
        searchFn() {
            this.pageNo = 1;
            this.getData(this.searchInfo);
        },
        exportFn() {
            let apiUrl = 'http://localhost.annto.com:8082';
            if (window.location.origin !== 'http://localhost.annto.com:8082') { apiUrl = config.apiUrl; }
            window.location = apiUrl + '/api-srm-web/bid/exportBidTenderSuppliers?supplierName=' +
                this.searchInfo.supplierName + '&tenderStatus=' + this.searchInfo.tenderStatus + '&tenderCode=' + this.tenderCode;
        },
        handleCurrentChange(val) {
            this.pageNo = val;
            this.getData();
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getData();
        },
        close() {
            this.warnShow = false;
            this.$emit('warnShowFunc', false);
        },
        recombination(list) {
            list.forEach(element => {
                element.tenderStatusText = this.dictData.BID_IS_SUBMIT[element.tenderStatus];
            });
            return list;
        },
        getData(searchInfo) {
            let par = {
                tenderCode: this.tenderCode,
                pageNo: this.pageNo,
                pageSize: this.pageSize
            };
            if (searchInfo) {
                par = { ...par, ...searchInfo };
            }
            bidTenderSuppliers(par).then(res => {
                if (res && +res.code === 0) {
                    this.roundwarntableList = this.recombination(res.data.list);
                    this.totalCount = res.data.totalCount;
                }
            });
        }
    },
    watch: {
        warnShowFlag(val) {
            if (val) {
                this.warnShow = val
                dictWithUrl('BID_IS_SUBMIT').then(res => {
                    const BID_IS_SUBMIT = res.data.BID_IS_SUBMIT
                    let optionArr = []
                    // 字典排序: 新建1->保存3->已提交2
                    let arr = ['1','3']
                    arr.forEach((v)=>{
                        for (const item in BID_IS_SUBMIT) {
                            if (item === v) {
                                optionArr.push({
                                    value: item,
                                    label: BID_IS_SUBMIT[item],
                                })
                                break
                            }
                        }
                    })
                    for (const item in BID_IS_SUBMIT) {
                        if (!arr.includes(item)) {
                            optionArr.push({
                                value: item,
                                label: BID_IS_SUBMIT[item],
                            })
                        }
                    }
                    this.dictData = res.data;
                    this.optionArr = optionArr;
                    setTimeout(() => {
                        this.optionArrKey++
                    }, 0);
                    this.getData()
                })
            }
        },
    }
};
</script>

<style lang="less">
.roundWarnDialog{
  .dialog-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>